const firebaseConfig = {
  apiKey: "AIzaSyBmsgWfrzsGSP3BFFpYA_aAoSsaXhbuU40",
  authDomain: "travel-guru-420.firebaseapp.com",
  databaseURL: "https://travel-guru-420.firebaseio.com",
  projectId: "travel-guru-420",
  storageBucket: "travel-guru-420.appspot.com",
  messagingSenderId: "385723072889",
  appId: "1:385723072889:web:d6029a9fdb2aa412866fa8",
};

export default firebaseConfig;
